module.exports = __webpack_public_path__ + "media/images/marble-pink-585e112b272395a478b95db6a8a5f7f2.jpg";